/**
 * When running in puppeteer, function is exposed on window that the page can call to abort screenshot/recording should it receive invalid pageData
 */
export const PageRenderErrorFunctionName = 'puppySnapInvalidPageData';  // shared with puppy-snap. todo: to shared package!

export const DomToPuppyCssId_ReadyToStart = 'forPuppy-readyToStart'; // move to shared constants; until published, must correspond with projects/puppy-snap/app/src/puppy-snap-app/page-signal-support.ts
export const DomToPuppyCssId_PageFinished = 'forPuppy-pageFinished';
export const DomToPuppyCssId_PageError = 'forPuppy-pageError';
